<div *ngIf="isOnline">

    <router-outlet></router-outlet>
</div>



  <div  *ngIf="!isOnline"
      class="d-flex flex-column justify-content-center align-items-center h-100 mb-4"
    >
        <img class="mb-3"
    src="assets/images/no-internet.svg"
    style="width: 350px; height: 350px"
  />
      <h6 class="fw-semibold mb-3">Oops! Something Went Wrong</h6>
      <span class="text-muted mb-4"> We couldn’t complete your request. Please try again. </span>
      <button class="btn btn-outline-dark btn-md" (click)="refresh()">Refresh</button>
    </div>
